import { render, staticRenderFns } from "./filter-shop-content.vue?vue&type=template&id=c5c29be2&scoped=true"
import script from "./filter-shop-content.vue?vue&type=script&lang=js"
export * from "./filter-shop-content.vue?vue&type=script&lang=js"
import style0 from "./filter-shop-content.vue?vue&type=style&index=0&id=c5c29be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c29be2",
  null
  
)

/* custom blocks */
import block0 from "./filter-shop-content.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports